import React, { useEffect } from "react";
import addIcon from "../../../assets/images/icons/add-icon.png";
import AddNewChallengeOverViewModal from "./AddNewChallengeOverViewModal";
import UploadJson from "../../../components/modals/UploadJson";

const AddNewChallengeButton = ({
                                 setCurrentModal,
                                 currentModal,
                                 openModal,
                                 modalAddBtn,
                                 selectedPlanId,
                                 handleFileUpload,
                                 handleSubmit,
                                 setPlanData,
                                 planData,
                                 errorMessage,
                                 fileName,
                                 onAddNewPlanClick,
                               }) => {
  const closeModal = () => {
    setCurrentModal(null);
  };
  useEffect(() => {
    if (selectedPlanId) {
      openModal(2);
    }
  }, [selectedPlanId]);
  return (
    <div>
      <button
        className="btn btn-primary"
        onClick={() => {
          onAddNewPlanClick();
          openModal(1);
        }}
      >
        <img src={addIcon} alt={modalAddBtn} />
        <span>{modalAddBtn}</span>
      </button>
      {currentModal === 1 && (
        <UploadJson
          onOpenModal2={() => openModal(2)}
          onClose={closeModal}
          onFileUpload={handleFileUpload}
          fileName={fileName}
          errorMessage={errorMessage}
        />
      )}
      {currentModal === 2 && (
        <AddNewChallengeOverViewModal
          challengeData={planData}
          setChallengeData={setPlanData}
          onClose={closeModal}
          onSubmit={handleSubmit}
          selectedPlanId={selectedPlanId}
        />
      )}
    </div>
  );
};

export default AddNewChallengeButton;
